import { defaultStringifySearch } from '@tanstack/react-router'

const stringifySearch = (search: Record<string, unknown>): string =>
	defaultStringifySearch(search).replaceAll('%2C', ',')

export { stringifySearch }
